import request from '@/api/request'

/**
 * 首页banner轮播图
 */
export const getHomeSection1Swiper = (params) => {
    return request({
        url: '/radioweb/app/web/getRotationPictureListPage',
        method: 'get',
        params
    })
}
/**
 * 首页名师轮播图
 */
export const getHomeTeacherSwiper = (params) => {
    return request({
        url: '/radioweb/app/web/getTeacherList',
        method: 'get',
        params
    })
}
/**
 * 获取合作单位分类
 */
export const getUnitClassList = () => {
    return request({
        url: '/radioweb/app/web/getUnitClassifyListPage',
        method: 'get'
    })
}
/**
 * 获取合作单位分类对应列表
 */
export const getUnitClassToUnitList = (params) => {
    return request({
        url: '/radioweb/app/web/getCooperationUnitListPage',
        method: 'get',
        params
    })
}
/**
 * 通知咨询，行业动态，政策文件，报名指南，考培资源列表（PC端）
 */
export const getListPublic = (params) => {
    return request({
        url: '/radioweb/app/web/getInformationListByClassId',
        method: 'get',
        params
    })
}
/**
 * 考试安排列表
 */
export const getTestList = (params) => {
    return request({
        url: '/radioweb/app/web/getExamPlanListPage',
        method: 'get',
        params
    })
}
/**
 * 登录
 */
export const toLogin = (data) => {
    return request({
        url: '/auth/login/admin/token/webSmscode',
        method: 'post',
        data
    })
}
/**
 * 通知咨询，行业动态，政策文件，报名指南，考培资源详情页
 */
export const getDetailPublic = (params) => {
    return request({
        url: '/radioweb/app/web/getInformationDescById',
        method: 'get',
        params
    })
}
/**
 * 通知咨询，行业动态，政策文件，报名指南，考培资源详情页es
 */
export const getDetailPublicES = (params) => {
    return request({
        url: '/radioweb/app/web/getInformationDescEsById',
        method: 'get',
        params
    })
}
/**
 * 获取用户信息
 */
export const getUserInfo = () => {
    return request({
        url: '/base/app/baseUser/getUserInfo',
        method: 'get',
        params: {}
    })
}
/**
 * 查询分页权威发布列表
 */
export const getAuthorityListByType = (params) => {
  return request({
    url: '/radioweb/app/web/getAuthorityListByType',
    method: 'get',
    params
  })
}
/**
 * 查询分页权威发布详情
 */
export const getAuthorityDescById = (params) => {
  return request({
    url: '/radioweb/app/web/getAuthorityDescById',
    method: 'get',
    params
  })
}
